import React, { useState } from 'react';
import { createPortal } from 'react-dom';

const AddCourseModal = ({ isOpen, onClose, onSubmit }) => {
    const [formData, setFormData] = useState({
        courseName: '',
        prerequisites: '',
        specialization: '',
        collegeName: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
        setFormData({
            courseName: '',
            prerequisites: '',
            specialization: '',
            collegeName: ''
        });
        onClose();
    };


    React.useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }


        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return createPortal(
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
            <div
                className="rounded-xl p-6 w-full max-w-2xl relative max-h-[90vh] overflow-y-auto scrollbar-hide"
                style={{
                    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)), radial-gradient(92.12% 184.55% at 50% -55%, rgba(40, 227, 218, 0.2) 0%, rgba(40, 227, 218, 0) 100%), rgb(8, 20, 35)',
                    borderRadius: '12px',
                    boxShadow: 'rgba(255, 255, 255, 0.08) 0px 8px 32px 0px',
                    backdropFilter: 'blur(2px)'
                }}
            >
                {                  }
                <button
                    onClick={onClose}
                    className="absolute top-4 left-4 w-8 h-8 bg-[#1a2a3a] rounded-lg flex items-center justify-center hover:bg-[#2a3a4a] transition-colors"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>

                {           }
                <div className="text-center mb-6">
                    <h2 className="text-2xl font-bold text-white mb-2">أضف بيانات المقرر</h2>
                    <p className="text-gray-300 text-sm">
                        يمكنك إضافة مقرر جديد مع جميع التفاصيل المطلوبة
                    </p>
                </div>



                {          }
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-white text-sm font-medium mb-2 text-right">
                            اسم المقرر
                        </label>
                        <input
                            type="text"
                            name="courseName"
                            value={formData.courseName}
                            onChange={handleInputChange}
                            required
                            className="w-full h-12 bg-[#12334a] rounded-xl border-none outline-none text-white px-4 text-sm font-[Alexandria] text-right"
                            placeholder="أدخل اسم المقرر"
                        />
                    </div>

                    <div>
                        <label className="block text-white text-sm font-medium mb-2 text-right">
                            متطلبات سابقة
                        </label>
                        <input
                            type="text"
                            name="prerequisites"
                            value={formData.prerequisites}
                            onChange={handleInputChange}
                            required
                            className="w-full h-12 bg-[#12334a] rounded-xl border-none outline-none text-white px-4 text-sm font-[Alexandria] text-right"
                            placeholder="أدخل المتطلبات السابقة"
                        />
                    </div>

                    <div>
                        <label className="block text-white text-sm font-medium mb-2 text-right">
                            التخصص
                        </label>
                        <input
                            type="text"
                            name="specialization"
                            value={formData.specialization}
                            onChange={handleInputChange}
                            required
                            className="w-full h-12 bg-[#12334a] rounded-xl border-none outline-none text-white px-4 text-sm font-[Alexandria] text-right"
                            placeholder="أدخل التخصص"
                        />
                    </div>

                    <div>
                        <label className="block text-white text-sm font-medium mb-2 text-right">
                            اسم الكلية
                        </label>
                        <input
                            type="text"
                            name="collegeName"
                            value={formData.collegeName}
                            onChange={handleInputChange}
                            required
                            className="w-full h-12 bg-[#12334a] rounded-xl border-none outline-none text-white px-4 text-sm font-[Alexandria] text-right"
                            placeholder="أدخل اسم الكلية"
                        />
                    </div>

                    {                   }
                    <div className="flex justify-center pt-4">
                        <button
                            type="submit"
                            className="w-32 h-10 border border-[#28e3da40] rounded-xl bg-transparent cursor-pointer flex items-center justify-center hover:bg-[#28e3da20] transition-colors"
                        >
                            <span className="font-[Alexandria] font-medium text-sm text-white">
                                إضافة
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>,
        document.body
    );
};

export default AddCourseModal;
